<template>
	<edit-column
		ref="form"
		v-bind="$attrs"
		v-on="$listeners"
		:title="title || 'Уред - замяна'"
		:params="{id:device,session}"
		:data.sync="data"
		:fields-callback="fields"
		:imodel="model"
		:edit-button-options="{showDelete:false}"
		:left-col-width="250"
		disabled-fields="old__device_N"
	>

		<template #before-fields>
			<v-row no-gutters>
				<v-col>
					<v-sheet rounded class="my-2 px-2 text-subtitle-1 red white--text">
						Стар уред
					</v-sheet>
				</v-col>
			</v-row>
		</template>

		<template #before-row.device_type_code="{}">
			<v-row no-gutters>
				<v-col>
					<v-sheet rounded class="my-2 px-2 text-subtitle-1 green white--text">
						Нов уред
					</v-sheet>
				</v-col>
			</v-row>
		</template>

		<template v-slot:field.device_model_id="{row,err}">
			<device-model
				label=""
				outlined
				dense
				name="device_model_id"
				hide-details="auto"
				:device-type="row.device_type_code"
				:data="row"
				:errors="err.device_model_id"
				:radio.sync="isModelRadio"
			/>
		</template>

		<template v-slot:field.device_N="{row,err,disabled}">
			<edit-input
				label=""
				outlined dense
				name="device_N"
				:data="row"
				:errors="err"
				:disabled="disabled"
			></edit-input>
			<dup-dev-num :number="row.device_N" :id="row.id" />
			<replacement-info :device-id="row.id" />
		</template>

		<template v-slot:field.reinstall_date="{row,err,disabled}">
			<edit-input
				label=""
				outlined dense
				name="reinstall_date"
				:data="row"
				:errors="err"
				:disabled="disabled"
			></edit-input>
			<em class="grey--text">Автоматично: 10 години след монтаж</em>
		</template>

		<template v-slot:field.device_type_code="{row,err}">
			<device-type-select
				:insert="true"
				label=""
				outlined dense
				name="device_type_code"
				:data="row"
				:errors="err"
				:disabled="true"
			></device-type-select>
		</template>

		<template v-slot:field.room="{row,err,disabled}">
			<data-loader :watch="roomOptionsParams" :callback="()=>model.getRoomOptions(roomOptionsParams.utility, roomOptionsParams.device_type_code)">
				<template #default="{data}">
					<edit-input
						type="combobox"
						label=""
						outlined dense
						name="room"
						:data="row"
						:errors="err"
						:disabled="disabled"
						:items="data"
					/>
				</template>
			</data-loader>
		</template>

		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>

	</edit-column>
</template>

<script>
import EditInput from "@/ittijs/Inputs/EditInput.vue";
import EditColumn from "@/ittijs/EditColumn.vue";
import DeviceTypeSelect from "@/ittijs/components/DeviceTypeSelect.vue";
import DeviceModel from "@/views/device_models/DeviceModelSelect.vue";
import DupDevNum from "@/views/clients_screen/DupDevNum.vue";
import DataLoader from "@/ittijs/components/DataLoader.vue";
import Devices from "@/views/devices/Model";
import {deviceInGroup, DeviceTypeGroupTypes} from "@/ittijs/Nomenclatures";
import SelectedUtilityMixin from "@/ittijs/SelectedUtilityMixin";
import ITTIModelProvider from "@/ittijs/ITTIModelProvider";
import ReplacementInfo from "@/ittijs/components/DeviceDataList/ReplacementInfo.vue";

class Model extends Devices {
	constructor() {
		super('DeviceReplace');
	}
}

export default {
	components: {ReplacementInfo, DataLoader, DupDevNum, DeviceModel, DeviceTypeSelect, EditColumn, EditInput},
	mixins: [
		SelectedUtilityMixin,
	],
	props: {
		device      : {},
		session     : {},
		title       : String,
		model       : {
			type: Object,
			default: () => ITTIModelProvider.getModel(Model),
		},
	},
	data(){
		return {
			data: null,
			isModelRadio: false,
		}
	},
	computed: {
		roomOptionsParams(){
			return {
				utility          : this.selectedUtility,
				device_type_code : this.data && this.data.device_type_code || null,
			}
		},
	},
	methods: {
		value2Visible(){
			try {
				return deviceInGroup(this.data.device_type_code, DeviceTypeGroupTypes.Value2);
			}
			catch (e) {
				return false;
			}
		},
		radioPropsVisible(){
			return this.isModelRadio;
		},
		fields(row){
			return [
				'old__device_N',
				'old__unmount_date',
				'old__unmount_value',
				this.value2Visible() ? 'old__unmount_value2' : null,
				'device_type_code',
				'device_model_id',
				'device_N',
				this.radioPropsVisible() ? 'radio_N' : null,
				'plomba_N',
				'mount_date',
				'mount_value',
				'reinstall_date',
				'wpl_id',
				'room',
				'radiator_factor',
				'radiator_power',
				'radiator_description',
				'notes',
			].filter(f=>!!f).filter(f=>this.model.getHiddenFieldsByType(row['device_type_code']).indexOf(f)===-1);
		},
		doSave(){
			return this.$refs.form.doSave();
		},
	},
}
</script>